


const getImageName = (url) => {
    const urlSplit = url.split('/');
    return urlSplit[urlSplit.length -1];
}

export {getImageName};